module.exports = __webpack_public_path__ + "static/media/debateImage2.00a29d54.png";